import type { PlaylistItem } from '@apm/contracts';
import { formatPrice } from '@apm/i18n';
import { useLocale } from '../i18n/LocaleProvider.js';

/**
 * 정보보기 오버레이. 좌측 하단.
 *
 * **네트워크 호출이 없다** (`docs/06-frontend-spec.md`). 표시할 값은 SDK 가 플레이리스트로
 * 이미 받아 둔 것뿐이다 — 여기서 상품 상세를 다시 불러오면 오버레이가 뜨는 데 왕복이 생기고,
 * 재생을 멈추지 않는다는 규칙의 취지(이탈 방지)가 무너진다.
 *
 * 영상 중앙을 가리지 않는다. 하단 1/3 영역만 쓴다.
 */
export function InfoOverlay({ item }: { item: PlaylistItem }) {
  const { locale } = useLocale();
  return (
    <div className="overlay overlay--info" role="status">
      {/* `data-i18n="data"` — 관리자가 넣은 값이다. 번역 대상이 아니고(`docs/22` §1)
          영어 화면에도 한국어로 남는다. **한글 훑기(`verify-locale.mjs`)가 이 표시를 보고
          건너뛴다** — 표시가 없으면 그 검사가 이것을 「번역 누락」으로 신고한다. */}
      <p className="overlay__category" data-i18n="data">
        {item.meta.category}
      </p>
      <p className="overlay__title" data-i18n="data">
        {item.title}
      </p>
      <p className="overlay__price">{formatPrice(item.price, locale)}</p>
    </div>
  );
}
